import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CanDeactivate, NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import * as $ from 'jquery';
import UIkit from 'uikit';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from '../../services/app.service';
import { Title } from '@angular/platform-browser';
import { User } from '../../_models/user.model';
import { AuthenticationService } from '../../services/authentication.service';
import { DialogService } from '../../services/dialog.service';
import { AnalyticsService } from '../../services/analytics.service';
import { formatDate } from '@angular/common';
import { CountdownComponent, CountdownConfig } from 'ngx-countdown';

declare var icogz: any;

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.css'],
})
export class OrderSummaryComponent
  implements OnInit, OnDestroy, CanDeactivate<Observable<any>>
{
  public state;
  public product;
  public productSchedule;
  public productDeal;
  currentUser: User;
  public promoError = '';
  public minDate;
  public maxDate;
  public productCheckUpdate;

  public latestProductSchedule;
  public productEventsAvailable = false;
  public calculatedPrice = 0;
  public isDataReady = false;
  public isAvailabilityPresent = true;
  public productEventsForDateAndTime: any;
  public countDownConfig: CountdownConfig = {
    demand: false,
    leftTime: 900,
    format: 'mm:ss',
  };
  public apiURL;
  public offers;

  // order related
  public isOrderPaymentDetailsReceived = false;
  public orderPaymentResponse: any;

  // social share
  public pageURL;
  public pageFeaturedImage;

  // user information
  public userDetails = {
    first_name: '',
    last_name: '',
    mobile_number: '',
    email: '',
  };
  public quickSignupPayLoad = { full_name: '', email: '', mobile_number: '' };

  //
  // enquiry api
  public enquiryResponseAwaited = false;
  public enquiryResponseReceived = false;
  public enquiryErrorMessage = '';
  public enquirySuccessful = false;
  public accessToken = '';

  // payment gateway
  rzp1: any;
  public paymentInProcess = false;
  public paymentCompleted = false;
  public razorPayOrderId = '';
  public t2dOrderId = '';
  public t2dInvoiceId = '';
  public signupErrorMessage = '';
  public checkoutError = '';
  public dateFilter: any;

  public NoOfGuests = [];

  // promocodes
  public promoCodeApplied = false;
  public couponCode = '';
  public couponResponse: any;

  //Check Balance
  public checkBalanceAccountError = '';
  public checkBalanceOTPError = '';
  public checkBalanceResponseReceived = false;
  checkBalanceErrorMessage = '';
  checkBalanceSuccessful = false;
  public checkBalancePayLoad = {
    mobilenumber: '',
    verify_redeem_otp: '',
  };
  public earnLoyaltyPayLoad = { earn_mobile_number: '' };
  public earnLoyaltyNewMemberPayLoad = {
    mobile_number: '',
    email: '',
    salutation: '',
    first_name: '',
    last_name: '',
    dob: '',
    privacy_checkbox: true,
    earn_validate_otp: '',
  };
  isPinShow = false;
  redeemPointsSuccess = false;
  submitRedeemPointsSuccessful = false;
  public useLoyPointsError = '';
  public GetAccountBalance;
  public loy_points_amount = 0;
  public block_loy_points_amount = 0;
  public ReceiptCode = '';
  public blockPointRedemptionResponse = '';
  public isRazorPayUse = 'No';
  public isTicketXpressUse = 'No';
  public acceptance_point_ref = this.randomString(25);
  public ticketxpress_remaining_value = '';
  public ticketXpressRemainingValue = 0;
  public authorization_id = '';
  public buyNowClick = 'No';
  public paybackOrderId = '';
  public paybackResult = '';
  public applyVoucherLoader = false;
  public resendOTPPaybackInProgress = false;
  public receivedResentOTPPaybackResponse = false;
  public earnLoyaltyMobileError = '';
  public earnLoyaltyAccountError = '';
  public EligiblePaybackAmount = 0;
  public earnLoyaltyNewMemberError = {
    mobile_number: '',
    email: '',
    salutation: '',
    first_name: '',
    last_name: '',
    dob: '',
    privacy_checkbox: '',
  };
  public AuthenticationNumber = '';
  public enrol_member_response = '';

  disableinput: boolean = true;

  @ViewChild('cd', { static: false }) private countdown: CountdownComponent;

  constructor(
    private http: HttpClient,
    public router: Router,
    private loadingBar: LoadingBarService,
    private appService: AppService,
    private authenticateService: AuthenticationService,
    private titleService: Title,
    public dialogService: DialogService,
    private analyticService: AnalyticsService
  ) {
    this.appService.userLoggedIn.subscribe((data) => {
      this.accessToken = localStorage.getItem('accessToken');
    });

    this.appService.userLoggedOut.subscribe((data) => {
      this.accessToken = '';
    });

    this.titleService.setTitle('Order Summary');
  }

  toggleShow() {
    if (this.currentUser) {
      this.earnLoyaltyPayLoad.earn_mobile_number =
        this.currentUser.mobile_number;
    }

    $('.earn-box').slideToggle();
    if (this.earnLoyaltyPayLoad.earn_mobile_number) {
      this.checkBalanceAccountError = '';
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      };
      const params = {
        mobile: this.earnLoyaltyPayLoad.earn_mobile_number,
      };

      this.http
        .post<any>(
          environment.domain + '/api/is-mobile-linked',
          params,
          httpOptions
        )
        .subscribe(
          (responseData) => {
            this.checkBalanceResponseReceived = true;
            if (responseData.data.status == 'YES') {
              this.AuthenticationNumber =
                this.earnLoyaltyPayLoad.earn_mobile_number;

              var eligible_points = 0;
              if (this.product.details.product_type !== 'STANDARD') {
                eligible_points = (this.productSchedule.event_price * 0.025) * 4;
              } else {
                eligible_points = (this.productDeal.deal_sale_price * this.productDeal.quantity * 0.0125) * 4;
              }
              this.EligiblePaybackAmount = Math.ceil(eligible_points);
              this.earnLoyaltyMobileError = '';
            } else {
              this.earnLoyaltyMobileError = 'Account not found';
              this.EligiblePaybackAmount = 0;
            }
          },
          (error) => {
            this.earnLoyaltyMobileError = 'Some error occurred.' + error;
            this.EligiblePaybackAmount = 0;
          }
        );
    }
  }

  openShareLink(): void {
    $('.sharelink').slideToggle();
  }

  handleCountDown(e): void {
    // {
    //     "action": "done",
    //     "left": 0,
    //     "status": 3,
    //     "text": "00:00:00"
    // }

    if (e.action === 'done' && !this.isOrderPaymentDetailsReceived) {
      this.abandonOrder(this.t2dOrderId, 'ABANDONED');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }

  addToWishlist(e): void {
    let w = $(e).attr('class');
    w == 'fa fa-bookmark-o'
      ? $(e).attr('class', 'fa fa-bookmark')
      : $(e).attr('class', 'fa fa-bookmark-o');
    if (w == 'fa fa-bookmark-o') {
      // add to wishlist
      this.appService.addToWishlist(this.product.id);
    } else {
      // remove from wishlist
      this.appService.removeFromWishlist(this.product.id);
    }
  }

  public loadJsFile(url) {
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  ngOnInit(): void {
    this.getOffers();
    this.apiURL = environment.domain;
    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 3);
    this.maxDate.setDate(this.minDate.getDate() + 90);
    this.loadJsFile('https://checkout.razorpay.com/v1/checkout.js');

    this.accessToken = localStorage.getItem('accessToken');

    this.authenticateService.currentUser.subscribe((x) => {
      this.currentUser = x;
      if (x) {
        this.earnLoyaltyPayLoad.earn_mobile_number =
          this.currentUser.mobile_number;
        this.earnLoyaltyCheck();
      }
    });
    if (localStorage.getItem('product')) {
      this.productSchedule = JSON.parse(localStorage.getItem('schedule'));
      this.product = JSON.parse(localStorage.getItem('product'));
      if (this.product.details.product_type === 'STANDARD') {
        this.productDeal = JSON.parse(localStorage.getItem('deal'));
      }

      this.pageURL =
        'https://things2.do/' +
        this.product.details.city.toLowerCase() +
        '/' +
        this.product.details.slug;

      this.product.product_images.forEach((element) => {
        this.pageFeaturedImage = element.images;
      });

      setTimeout((c) => {
        const icogzEvent = {
          customer_id: this.currentUser?.id ? this.currentUser.id : 0,
          product_id: this.product.details.id || 0,
          //        product_name: this.product.details.title || '',
          deal_id: this.productDeal?.deal_id || 0,
          //          deal_name: this.productDeal.deal_title || ''
        };
        console.log(icogzEvent);
        icogz.trackEvent(JSON.stringify(icogzEvent), 'cart-page');



      }, 3000);

      if (this.product.details.product_type !== 'STANDARD') {
        // calculated price
        this.calculatedPrice = this.productSchedule.price;
      }

      // load profile information from the storage.
      // this.userDetails = this.appService.getUserDetails();

      this.userDetails.first_name = localStorage.getItem('first_name');
      this.userDetails.last_name = localStorage.getItem('last_name');
      this.userDetails.email = localStorage.getItem('email') || '';
      this.userDetails.mobile_number = localStorage.getItem('mobile_number');
      this.isDataReady = true;

      this.getProductAvailability();
      this.analyticService.checkOut(this.product, this.productDeal);
    }

    this.productCheckUpdate = setInterval(() => {
      console.log('Checking product');
      this.getProductDetails();

      if (this.product.details.product_type === 'EXPERIENCE') {
        this.getProductAvailability();
      }
    }, 5000);

    //var today = new Date().toISOString().split('T')[0];
    var today = new Date(new Date().setDate(new Date().getDate() - 1))
      .toISOString()
      .split('T')[0];
    document.getElementsByName('dob')[0].setAttribute('max', today);
  }

  increaseQty(selectedDeal): void {
    if (selectedDeal.deal_limited === 1) {
      this.productDeal.quantity = 1;
      return;
    }

    if (selectedDeal.deal_id !== this.productDeal.deal_id) {
      this.productDeal.quantity = 1;
    }

    if (selectedDeal.deal_stock > 0) {
      this.productDeal = selectedDeal;
      if (
        this.productDeal.quantity < this.productDeal.deal_stock &&
        this.productDeal.quantity < 30
      ) {
        this.productDeal.quantity++;
      }
    }
  }

  decreaseQty(selectedDeal): void {
    if (selectedDeal.deal_limited === 1) {
      this.productDeal.quantity = 1;
      return;
    }

    if (selectedDeal.deal_id !== this.productDeal.deal_id) {
      this.productDeal.quantity = 1;
    }

    if (selectedDeal.deal_stock > 0) {
      this.productDeal = selectedDeal;
      if (this.productDeal.quantity > 1) {
        this.productDeal.quantity--;
      }
    }
  }

  changeEarnPoint(): void {
    if (this.EligiblePaybackAmount > 0) {
      var totalPrice =
        this.productDeal.deal_sale_price * this.productDeal.quantity +
        (this.productDeal.deal_sale_price *
          this.productDeal.quantity *
          this.productDeal.deal_convenience_fee) /
        100;
      var eligible_points = 0;
      if (this.product.details.product_type !== 'STANDARD') {
        eligible_points = (this.productSchedule.event_price * 0.025) * 4;
      } else {
        eligible_points = (this.productDeal.deal_sale_price * this.productDeal.quantity * 0.0125) * 4;
      }
      this.EligiblePaybackAmount = Math.ceil(eligible_points);
    }
  }
  /**
   * Get the availability details for the current product.
   */
  getProductAvailability(): void {
    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    this.http
      .post<any>(
        environment.domain +
        '/api/' +
        this.product.details.city.toLowerCase() +
        '/product-event',
        { slug: this.product.details.slug },
        httpOptions
      )
      .subscribe(
        (data) => {
          this.loadingBar.stop();
          this.productEventsAvailable = true;
          this.latestProductSchedule = data.event_date;
          const availableDates = [];

          for (var key in this.latestProductSchedule) {
            availableDates.push(key);
          }

          // disable the dates not present.
          this.dateFilter = (d: Date | null): boolean => {
            const time = formatDate(d.getTime(), 'Y-MM-dd', 'en-us');
            return availableDates.find((x) => x == time);
          };

          this.productEventsForDateAndTime = Object.assign(
            {},
            this.latestProductSchedule
          );
          if (this.productSchedule.date) {
            this.productEventsForDateAndTime = this.productEventsForDateAndTime[
              this.productSchedule.date
            ].filter((x) => x.time_from === this.productSchedule.time_from);

            console.log('events date time', this.productEventsForDateAndTime);

            if (this.productEventsForDateAndTime) {
              this.NoOfGuests = [];
              this.NoOfGuests = [
                ...new Set(
                  this.productEventsForDateAndTime.map((item) => item.ppl)
                ),
              ];
              console.log('no of guests', this.NoOfGuests);

              this.setPrice();
            }
          }
        },
        (error) => {
          this.loadingBar.stop();
          console.error('There was an error!', error);
        }
      );
  }

  fillTime(e): void {
    this.productSchedule.date = e.value;
    this.productSchedule.time = '';
    this.productSchedule.ppl = '';
    this.checkoutError = '';

    this.calculatedPrice = 0;
    this.productEventsForDateAndTime = Object.assign(
      {},
      this.latestProductSchedule
    );

    if (this.productEventsForDateAndTime[this.productSchedule.date]) {
      if (
        this.productEventsForDateAndTime[this.productSchedule.date].length === 1
      ) {
        this.productSchedule.time =
          this.productEventsForDateAndTime[this.productSchedule.date][0]
            .time_from +
          '-' +
          this.productEventsForDateAndTime[this.productSchedule.date][0]
            .time_to;
      }

      if (
        !this.productEventsForDateAndTime[this.productSchedule.date] ||
        this.productEventsForDateAndTime[this.productSchedule.date].length === 0
      ) {
        this.productSchedule.time = '';
      }

      console.log('Time', this.productSchedule.time);
      console.log(
        'Time 2',
        this.latestProductSchedule[this.productSchedule.date]
      );

      if (
        this.productEventsForDateAndTime[this.productSchedule.date].length === 0
      ) {
        this.isAvailabilityPresent = false;
      } else {
        this.isAvailabilityPresent = true;
      }

      this.fillGuests();
    } else {
      this.isAvailabilityPresent = false;
    }
  }

  fillGuests(): void {
    this.calculatedPrice = 0;
    const time_range = this.productSchedule.time.split('-');

    this.productSchedule.time_from = time_range[0];
    this.productSchedule.time_to = time_range[1];

    this.productEventsForDateAndTime = Object.assign(
      {},
      this.latestProductSchedule
    );
    if (this.productSchedule.date) {
      this.productEventsForDateAndTime = this.productEventsForDateAndTime[
        this.productSchedule.date
      ].filter((x) => x.time_from == this.productSchedule.time_from);
    }

    this.NoOfGuests = [];
    this.NoOfGuests = [
      ...new Set(this.productEventsForDateAndTime.map((item) => item.ppl)),
    ];

    if (this.NoOfGuests.length === 1) {
      this.productSchedule.ppl = this.NoOfGuests[0];
    }

    if (this.NoOfGuests.length === 0) {
      this.productSchedule.ppl = 0;
    }

    this.setPrice();
  }

  setPrice(): void {
    this.productEventsForDateAndTime.forEach((item) => {
      // tslint:disable-next-line:triple-equals
      if (this.productSchedule.ppl == item.ppl) {
        this.calculatedPrice = item.price;
        this.productSchedule.event_price = item.price;
        return;
      }
    });
  }

  // todo: need to change this.
  // temporary short cuts..
  validateEmail(email) {
    const re = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return re.test(email);
  }

  showLoginForm() {
    UIkit.modal('#modal-center').show();
  }

  validPhoneNumber(inputtxt): boolean {
    const phoneno = /^\d{10}$/;
    if (inputtxt.match(phoneno)) {
      return true;
    } else {
      return false;
    }
  }

  quickSignup(): void {
    if (!this.accessToken) {
      this.signupErrorMessage = '';

      if (
        this.quickSignupPayLoad.email === '' ||
        this.quickSignupPayLoad.mobile_number === '' ||
        this.quickSignupPayLoad.full_name === ''
      ) {
        this.signupErrorMessage = 'All fields are required';
        return;
      }

      if (this.quickSignupPayLoad.full_name.length < 3) {
        this.signupErrorMessage = 'Name is too short';
        return;
      }

      if (!this.validateEmail(this.quickSignupPayLoad.email)) {
        this.signupErrorMessage = 'Invalid Email';
        return;
      }

      if (!this.validPhoneNumber(this.quickSignupPayLoad.mobile_number)) {
        this.signupErrorMessage = 'Invalid Mobile Number';
        return;
      }

      // get the access token
      const loginHttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      };

      this.http
        .post<any>(
          environment.domain + '/api/quick-sign-up',
          this.quickSignupPayLoad,
          loginHttpOptions
        )
        .subscribe(
          (data) => {
            if (data.type === 'success') {
              // get order id
              this.accessToken = data.access_token;
              localStorage.setItem('accessToken', data.access_token);
              localStorage.setItem('first_name', data.profile.first_name);
              localStorage.setItem('last_name', data.profile.last_name);
              localStorage.setItem('email', data.profile.email);
              localStorage.setItem('city', data.profile.city);
              localStorage.setItem('mobile_number', data.profile.mobile_number);

              this.addToCart();
            }
          },
          (error) => {
            console.error('There was an error!', error);
            this.loadingBar.stop();
            this.signupErrorMessage = 'Some error occurred!';
            return;
          }
        );
    }
  }

  /**
   * Redeem Points
   * * */
  blockPointForRedemption(orderId): void {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    const params = {
      PrincipalValue: this.checkBalancePayLoad.mobilenumber,
      InvoiceNum: orderId,
      ReceiptCode: orderId,
      PointsToBlock: this.loy_points_amount * 4,
      TxnChannel: 'PONL',
      OTP: this.checkBalancePayLoad.verify_redeem_otp,
      sendSMS: 'YES',
    };
    this.http
      .post<any>(
        environment.domain + '/api/block-points-for-redemption',
        params,
        httpOptions
      )
      .subscribe(
        (resultData) => {
          console.log(resultData);
          if (resultData.type == 'success') {
            this.block_loy_points_amount = this.loy_points_amount;
            if (resultData.data.ErrorMessage != '') {
              this.checkBalanceOTPError = resultData.data.ErrorMessage;
            } else {
              this.blockPointRedemptionResponse = resultData.data;
              UIkit.modal('#modal-block-points-redemption').hide();
              let total_amount = $('.total-amount-balance')
                .text()
                .replaceAll(',', '');
              total_amount = total_amount.match(/\d+/g);
              this.paybackOrderId = resultData.data.OrderId;
              this.paybackResult = resultData.data;
              this.checkBalanceOTPError = '';
              UIkit.modal('#modal-buy-now-after-verify').show();
            }
          } else {
            this.checkBalanceOTPError = 'Redemption Cancel';
          }
        },
        (error) => {
          console.error('There was an error!', error);
        }
      );
  }
  earnPointGet(): any {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    const params = {
      mobile: $('#earn_mobile_number').val(),
    };

    this.http
      .post<any>(
        environment.domain + '/api/is-mobile-linked',
        params,
        httpOptions
      )
      .subscribe(
        (responseData) => {
          this.checkBalanceResponseReceived = true;
          if (responseData.data.status == 'YES') {
            this.AuthenticationNumber = $('#earn_mobile_number').val();
            let total_amount = $('.total-amount-balance')
              .text()
              .replaceAll(',', '');
            total_amount = total_amount.match(/\d+/g);
            var eligible_points = 0;
            if (this.product.details.product_type !== 'STANDARD') {
              eligible_points = (this.productSchedule.event_price * 0.025) * 4;
            } else {
              eligible_points = (this.productDeal.deal_sale_price * this.productDeal.quantity * 0.0125) * 4;
            }
            this.EligiblePaybackAmount = Math.ceil(eligible_points);
            return Math.ceil(eligible_points);
          } else {
            this.earnLoyaltyMobileError = 'Account not found';
            this.EligiblePaybackAmount = 0;
            return 0;
          }
        },
        (error) => {
          this.earnLoyaltyMobileError = 'Some error occurred.' + error;
          this.EligiblePaybackAmount = 0;
          return 0;
        }
      );
  }
  verifyOtpForRedeemPoints(): void {
    if (
      $('#earnLoyalty').prop('checked') == true &&
      $('#earn_mobile_number').val() == ''
    ) {
      this.earnLoyaltyMobileError =
        'Please enter mobile number for Earn Loyalty Coins';
    } else {
      this.earnLoyaltyMobileError == '';
      let points = this.earnPointGet();
      let total_amount = $('.total-amount-balance').text().replaceAll(',', '');
      total_amount = total_amount.match(/\d+/g);

      if (this.checkBalanceOTPError == '') {
        clearInterval(this.productCheckUpdate);

        // add to cart
        this.signupErrorMessage = '';
        this.enquiryErrorMessage = '';
        this.enquiryResponseReceived = false;

        UIkit.tab('.tabs-link').show(1);

        this.paymentInProcess = true;
        this.loadingBar.start();

        let params: any;
        let apiPath = '';

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: this.accessToken,
          }),
        };

        if (this.product.details.product_type === 'STANDARD') {
          const standardParams = {
            product_id: this.product.details.id,
            ppl: this.productDeal.deal_valid_for ?? '',
            deal_id: this.productDeal.deal_id ?? '',
            quantity: this.productDeal.quantity ?? 1,
            event_price: this.productDeal.deal_sale_price,
          };
          params = standardParams;
          apiPath = '/api/add-to-cart/Standard';
        } else {
          const premiumParams = {
            product_id: this.product.details.id,
            event_date: this.productSchedule.date,
            ppl: this.productSchedule.ppl,
            deal_id: 0,
            event_price: this.productSchedule.event_price,
            time_to: this.productSchedule.time_to,
            time_from: this.productSchedule.time_from,
            rowid: 1,
          };
          params = premiumParams;
          apiPath = '/api/add-to-cart';
        }
        if (
          this.EligiblePaybackAmount > 0 ||
          total_amount[0] == 0 ||
          $('#earnLoyalty').prop('checked') == false
        ) {
          this.http
            .post<any>(environment.domain + apiPath, params, httpOptions)
            .subscribe(
              (data) => {
                if (data.type === 'success') {
                  const httpOptions = {
                    headers: new HttpHeaders({
                      'Content-Type': 'application/json',
                      Authorization: localStorage.getItem('accessToken'),
                    }),
                  };

                  const params = {
                    couponName: this.couponCode,
                    isTicketXpressUse: this.isTicketXpressUse,
                    couponResponse: this.couponResponse,
                    edr_value: this.authorization_id,
                    acceptance_point_ref: this.randomString(25),
                    voucher_ref: this.couponCode,
                    voucher_value: this.ticketxpress_remaining_value,
                    ticketXpressRemainingValue: this.ticketXpressRemainingValue,
                    voucher_product_class: 'ETX_001',
                    customer_details_email_address: this.currentUser.email,
                    customer_details_phone_number:
                      this.currentUser.mobile_number,
                    is_payback_use: this.loy_points_amount > 0 ? 'Yes' : 'No',
                    is_redeem: 'No',
                    loy_points_use: this.loy_points_amount > 0 ? 'Yes' : 'No',
                    loy_amount: this.loy_points_amount,
                    loy_card_number:
                      this.loy_points_amount > 0
                        ? this.GetAccountBalance.LoyaltyCardNumber
                        : '',
                    enrol_member_response: this.enrol_member_response,
                  };

                  if (!this.promoCodeApplied) {
                    params.couponName = '';
                  }

                  this.http
                    .post<any>(
                      environment.domain + '/api/orders',
                      params,
                      httpOptions
                    )
                    .subscribe(
                      (data) => {
                        if (data.type === 'success') {
                          if (this.loy_points_amount > 0) {
                            this.blockPointForRedemption(data.data.invoice_number);
                          }
                          // set order id
                          this.razorPayOrderId = data.data.razor_pay_order_id;
                          this.t2dOrderId = data.data.order_id;
                          this.t2dInvoiceId = data.data.invoice_number;

                          this.paymentInProcess = false;
                          //Add By Now Popup After Verify OTP

                        } else {
                          this.checkoutError = data.message;
                        }
                      },
                      (error) => {
                        console.error('There was an error!', error);
                        this.loadingBar.stop();
                      }
                    );
                } else {
                  UIkit.tab('.tabs-link').show(0);
                  this.checkoutError = data.message;
                }

                this.paymentInProcess = false;
              },
              (error) => {
                console.error('There was an error!', error);
                this.loadingBar.stop();
                UIkit.tab('.tabs-link').show(0);
                this.checkoutError = error.error.message;
                this.paymentInProcess = false;
              }
            );
        }
      } else {
        this.blockPointForRedemption(this.t2dInvoiceId);
      }
    }
  }
  addToCartPayback(): void {
    UIkit.modal('#modal-buy-now-after-verify').hide();
    let total_amount = $('.total-amount-balance').text().replaceAll(',', '');
    total_amount = total_amount.match(/\d+/g);
    if (total_amount[0] > 0) {
      this.setupPaymentGateway(
        this.razorPayOrderId,
        this.product.details.title
      );
      this.rzp1.open();
    } else {
      if (this.loy_points_amount > 0 && total_amount[0] == 0) {
        this.updatePaymentResponse(
          this.paybackOrderId,
          'PROCESSING',
          this.paybackResult
        );
      }
    }

    this.paymentInProcess = false;
  }
  /**
   * Add this product to the cart
   */
  addToCart(validateForm = true): boolean {
    //let points = this.earnPointGet();
    // let total_amount = $('.total-amount-balance').text().replaceAll(',', '');
    // total_amount = total_amount.match(/\d+/g);

    // this.earnLoyaltyMobileError == '';
    clearInterval(this.productCheckUpdate);

    // add to cart
    this.signupErrorMessage = '';
    this.enquiryErrorMessage = '';
    this.enquiryResponseReceived = false;

    if (
      validateForm === true &&
      this.product.details.product_type !== 'STANDARD'
    ) {
      if (
        !this.productSchedule.date ||
        this.productSchedule.date === '' ||
        this.productSchedule.date === 0
      ) {
        this.enquiryResponseReceived = true;
        this.checkoutError = 'Please select the date and time slot. ';
        return false;
      }
    }

    UIkit.tab('.tabs-link').show(1);

    this.paymentInProcess = true;
    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.accessToken,
      }),
    };

    let params: any;
    let apiPath = '';

    if (this.product.details.product_type === 'STANDARD') {
      const standardParams = {
        product_id: this.product.details.id,
        ppl: this.productDeal.deal_valid_for ?? '',
        deal_id: this.productDeal.deal_id ?? '',
        quantity: this.productDeal.quantity ?? 1,
        event_price: this.productDeal.deal_sale_price,
      };
      params = standardParams;
      apiPath = '/api/add-to-cart/Standard';
    } else {
      const premiumParams = {
        product_id: this.product.details.id,
        event_date: this.productSchedule.date,
        ppl: this.productSchedule.ppl,
        deal_id: 0,
        event_price: this.productSchedule.event_price,
        time_to: this.productSchedule.time_to,
        time_from: this.productSchedule.time_from,
        rowid: 1,
      };
      params = premiumParams;
      apiPath = '/api/add-to-cart';
    }

    // if (
    //   this.EligiblePaybackAmount > 0 ||
    //   //total_amount[0] == 0 ||
    //   $('#earnLoyalty').prop('checked') == false
    // ) {
    this.http
      .post<any>(environment.domain + apiPath, params, httpOptions)
      .subscribe(
        (data) => {
          if (data.type === 'success') {
            this.getRazorPayOrderID();
          } else {
            UIkit.tab('.tabs-link').show(0);
            this.checkoutError = data.message;
          }

          this.paymentInProcess = false;
        },
        (error) => {
          console.error('There was an error!', error);
          this.loadingBar.stop();
          UIkit.tab('.tabs-link').show(0);
          this.checkoutError = error.error.message;
          this.paymentInProcess = false;
        }
      );
    //}

    // on response open the payment dialog
  }

  /**
   * Get order id for this product.
   */
  getRazorPayOrderID() {
    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('accessToken'),
      }),
    };

    const params = {
      couponName: this.couponCode,
      isTicketXpressUse: this.isTicketXpressUse,
      couponResponse: this.couponResponse,
      edr_value: this.authorization_id,
      acceptance_point_ref: this.randomString(25),
      voucher_ref: this.couponCode,
      voucher_value: this.ticketxpress_remaining_value,
      ticketXpressRemainingValue: this.ticketXpressRemainingValue,
      voucher_product_class: 'ETX_001',
      customer_details_email_address: this.currentUser.email,
      customer_details_phone_number: this.currentUser.mobile_number,
      is_payback_use: this.loy_points_amount > 0 ? 'Yes' : 'No',
      is_redeem: 'No',
      loy_points_use: this.loy_points_amount > 0 ? 'Yes' : 'No',
      loy_amount: this.loy_points_amount,
      loy_card_number:
        this.loy_points_amount > 0
          ? this.GetAccountBalance.LoyaltyCardNumber
          : '',
      enrol_member_response: this.enrol_member_response,
    };

    if (!this.promoCodeApplied) {
      params.couponName = '';
    }

    this.http
      .post<any>(environment.domain + '/api/orders', params, httpOptions)
      .subscribe(
        (data) => {
          if (data.type === 'success') {
            // set order id
            this.razorPayOrderId = data.data.razor_pay_order_id;
            this.t2dOrderId = data.data.order_id;
            console.log('order id', this.t2dOrderId);

            let total_amount = $('.total-amount-balance')
              .text()
              .replaceAll(',', '');
            total_amount = total_amount.match(/\d+/g);
            if (total_amount[0] > 0) {
              this.setupPaymentGateway(
                this.razorPayOrderId,
                this.product.details.title
              );
              this.rzp1.open();
            } else if (
              total_amount[0] == 0
              // &&
              // this.isTicketXpressUse == 'Yes'
            ) {
              this.updatePaymentResponse('', 'PROCESSING', '');
            }

            this.paymentInProcess = false;
          } else {
            this.checkoutError = data.message;
          }
        },
        (error) => {
          console.error('There was an error!', error);
          this.loadingBar.stop();
        }
      );

    // on response open the payment dialog
  }

  @HostListener('window:payment.success', ['$event'])
  onPaymentSuccess(event): void {
    this.updatePaymentResponse(
      event.detail.razorpay_payment_id,
      'PROCESSING',
      event.detail
    );
  }

  /**
   * Prepare the payment form.
   *
   * @param orderID
   * @param productDescription
   */
  setupPaymentGateway(orderID, productDescription): void {
    this.isRazorPayUse = 'Yes';
    const options = {
      // key: 'rzp_test_FrLNnzFv7cMf0R', // Enter the Key ID generated from the Dashboard
      key: 'rzp_live_xJqpcE0QNfoTXI',
      currency: 'INR',
      name: 'Things2do',
      description: productDescription,
      image: 'https://things2.do/assets/images/logo.png',
      order_id: orderID, // This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      handler(response) {
        if (response.code != 'BAD_REQUEST_ERROR') {
          let event = new CustomEvent('payment.success', {
            detail: response,
          });
          window.dispatchEvent(event);
        }
      },
      prefill: {
        name:
          this.currentUser.first_name ??
          '' + '' + this.currentUser.last_name ??
          '',
        email: this.currentUser.email,
        contact: this.currentUser.mobile_number,
      },
      notes: {
        address: '',
      },
      theme: {
        color: '#ffde00',
      },
      modal: {
        ondismiss: () => {
          console.log('payment cancelled');
          this.abandonOrder(this.t2dOrderId);
        },
      },
    };

    // @ts-ignore
    this.rzp1 = new Razorpay(options);
    this.rzp1.on('payment.failed', (response) => {
      console.log(response.error);
      this.updatePaymentResponse(
        response.error.metadata.payment_id,
        'FAILED',
        response
      );
    });
  }

  /**
   *
   * @param razorPayPaymentID
   */
  updatePaymentResponse(
    razorPayPaymentID,
    orderStatus = 'PROCESSING',
    razorPayResponse: any
  ): void {
    this.paymentInProcess = true;
    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('accessToken'),
      }),
    };

    if (orderStatus !== 'PROCESSING') {
      icogz.trackEvent(
        JSON.stringify({
          user_id: this.currentUser.id,
          order_id: this.t2dOrderId,
        }),
        'purchase_failed'
      );
    }

    console.log('order id', this.t2dOrderId);
    let TxnAmount = 0;
    if (this.product.details.product_type !== 'STANDARD') {
      TxnAmount = this.productSchedule.event_price;
    } else {
      TxnAmount = this.productDeal.deal_sale_price * this.productDeal.quantity;
    }

    let convenienceFee = $('.convenienceFee')
      .text()
      .replaceAll(',', '');
    convenienceFee = convenienceFee.match(/\d+/g);
    if (convenienceFee > 0) {
      TxnAmount = Math.round(parseFloat(convenienceFee) + TxnAmount);
    }
    const params = {
      order_id: this.t2dOrderId,
      status: orderStatus,
      razor_payment_id: razorPayPaymentID,
      razor_order_id: this.razorPayOrderId,
      isRazorPayUse: this.isRazorPayUse,
      isTicketXpressUse: this.isTicketXpressUse,
      response:
        this.isRazorPayUse == 'Yes' ? JSON.stringify(razorPayResponse) : '',
      is_payback_use: this.loy_points_amount > 0 ? 'Yes' : 'No',
      payback_response:
        this.loy_points_amount > 0
          ? JSON.stringify(this.blockPointRedemptionResponse)
          : '',
      eligible_payback_points: this.EligiblePaybackAmount,
      AuthenticationNumber: this.AuthenticationNumber,
      TxnPoints: this.EligiblePaybackAmount,
      TxnAmount: TxnAmount,
      TxnSettlementDate: this.product.details.product_type !== 'STANDARD' ? this.productSchedule.date : ''
    };

    this.http
      .post<any>(environment.domain + '/api/orders-status', params, httpOptions)
      .subscribe(
        (data) => {
          this.paymentInProcess = false;
          this.isOrderPaymentDetailsReceived = true;
          this.orderPaymentResponse = data.data;
          UIkit.modal('#modal-buy-now-after-verify').hide();
          $('.order-step-tabs').hide();
          UIkit.tab('.tabs-link').show(2);
          $('.confirmation-wrp').show();
          this.paymentCompleted = true;
          this.analyticService.purchaseComplete(
            this.product,
            this.productDeal,
            this.orderPaymentResponse,
            this.couponCode
          );
        },
        (error) => {
          console.error('There was an error!', error);
          this.loadingBar.stop();
        }
      );
  }

  getOffers(): void {
    // this.loadingBar.start();
    // this.http.get<any>(environment.domain + '/api/' + this.appService.getCurrentCity().toLowerCase() + '/offers').subscribe(
    //   data => {
    //     this.offers = data.data;
    //   },
    //   error => {
    //     this.loadingBar.stop();
    //   });
  }

  openOffersModal(offerID): void {
    UIkit.modal('#modal-offer_' + offerID).show();
  }

  abandonOrder(orderID, orderStatus = 'ABANDONED'): void {
    this.paymentInProcess = true;
    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('accessToken'),
      }),
    };

    icogz.trackEvent(
      JSON.stringify({
        user_id: this.currentUser.id,
        order_id: this.t2dOrderId,
      }),
      'purchase_abandoned'
    );

    console.log('order id', this.t2dOrderId);
    const params = {
      order_id: this.t2dOrderId,
      status: orderStatus,
    };

    this.http
      .post<any>(environment.domain + '/api/order-abandon', params, httpOptions)
      .subscribe(
        (data) => {
          this.paymentInProcess = false;
          this.isOrderPaymentDetailsReceived = false;
        },
        (error) => {
          console.error('There was an error!', error);
          this.loadingBar.stop();
        }
      );
  }

  removeCoupon(): void {
    this.applyVoucherLoader = false;
    this.promoCodeApplied = false;
    this.couponCode = '';
    this.couponResponse = null;
    this.setPrice();
  }

  removeTicketXpressVoucher(): void {
    if (this.couponCode.slice(0, 4) == 'T2DE') {
      this.removeCoupon();
    } else {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      };
      const params = {
        acceptance_point_ref: this.randomString(25),
        edr_value: this.authorization_id,
        voucher_ref: this.couponCode,
        voucher_value: this.ticketxpress_remaining_value,
        ticketXpressRemainingValue: this.ticketXpressRemainingValue,
        voucher_product_class: 'ETX_001',
        currency: 'INR',
      };
      this.http
        .post<any>(environment.domain + '/api/cancel', params, httpOptions)
        .subscribe(
          (responseData) => {
            if (responseData.type === 'success') {
              this.promoCodeApplied = false;
              this.couponCode = '';
              this.isTicketXpressUse = 'No';
              this.couponResponse = null;
              this.ticketxpress_remaining_value = '';
              this.ticketXpressRemainingValue = 0;
              this.authorization_id = '';
              this.applyVoucherLoader = false;
            } else {
              this.promoError = 'There was an error!';
              this.applyVoucherLoader = false;
            }
            this.loadingBar.stop();
            this.applyVoucherLoader = false;
          },
          (error) => {
            this.loadingBar.stop();
            this.applyVoucherLoader = false;
          }
        );
    }
  }

  randomString(length) {
    var randomChars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(
        Math.floor(Math.random() * randomChars.length)
      );
    }
    return result;
  }
  applyTicketXpressVoucher(): void {
    this.applyVoucherLoader = true;
    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    this.promoError = '';
    let totalPrice = 0;

    if (this.product.details.product_type !== 'STANDARD') {
      totalPrice = this.calculatedPrice
        ? this.calculatedPrice
        : this.product.details.sale_price;
    } else {
      totalPrice =
        this.productDeal.deal_sale_price * this.productDeal.quantity +
        (this.productDeal.deal_sale_price *
          this.productDeal.quantity *
          this.productDeal.deal_convenience_fee) /
        100;
    }

    if (this.couponCode) {

      if (this.couponCode.slice(0, 4) == 'T2DE') {
        this.applyCoupon();
      } else {
        const httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };
        const params = {
          voucher_code: 'ETX_001-' + this.couponCode,
        };

        this.http
          .post<any>(environment.domain + '/api/get-voucher', params, httpOptions)
          .subscribe(
            (resultData) => {
              if (resultData.type === 'success') {
                // this.promoCodeApplied = true;

                if (resultData.data.meta.status == 'succeeded') {
                  let getVoucherResponse = resultData.data.data;
                  this.ticketxpress_remaining_value =
                    resultData.data.data.remaining_value;

                  const params = {
                    acceptance_point_ref: this.randomString(25),
                    currency: 'INR',
                    voucher_ref: this.couponCode,
                    voucher_value: getVoucherResponse.remaining_value,
                    voucher_product_class: 'ETX_001',
                  };
                  this.http
                    .post<any>(
                      environment.domain + '/api/authorization',
                      params,
                      httpOptions
                    )
                    .subscribe(
                      (responseData) => {
                        if (responseData.type === 'success') {
                          if (responseData.data.meta.status == 'succeeded') {
                            this.applyVoucherLoader = false;
                            this.promoCodeApplied = true;
                            this.isTicketXpressUse = 'Yes';
                            this.couponResponse = resultData.data.data;
                            this.authorization_id =
                              responseData.data.data.authorization_id;
                            let total_amount = $('.total-amount-balance')
                              .text()
                              .replaceAll(',', '');
                            total_amount = total_amount.match(/\d+/g);
                            if (
                              responseData.data.data.authorized_amount / 100 >
                              total_amount[0]
                            ) {
                              this.ticketXpressRemainingValue = total_amount[0];
                            } else {
                              this.ticketXpressRemainingValue =
                                responseData.data.data.authorized_amount / 100;
                            }
                          } else {
                            this.promoError = 'Sorry, Voucher not found';
                            this.applyVoucherLoader = false;
                          }
                        } else {
                          this.promoError = 'There was an error!';
                          this.applyVoucherLoader = false;
                        }
                        this.loadingBar.stop();
                        this.applyVoucherLoader = false;
                      },
                      (error) => {
                        this.loadingBar.stop();
                        this.applyVoucherLoader = false;
                      }
                    );
                } else {
                  this.promoError =
                    'Sorry, ' + resultData.data.meta.messages[0]['text'];
                }
              } else {
                this.promoError = 'There was an error!';
                this.applyVoucherLoader = false;
              }
              this.loadingBar.stop();
              this.applyVoucherLoader = false;
            },
            (error) => {
              console.error('There was an error!', error);
              this.loadingBar.stop();
              this.applyVoucherLoader = false;
            }
          );
      }

    } else {
      this.promoError = 'Please enter voucher number';
      this.loadingBar.stop();
      this.applyVoucherLoader = false;
    }
  }

  applyCoupon(): void {

    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    this.promoError = '';
    let totalPrice = 0;

    if (this.product.details.product_type !== 'STANDARD') {
      totalPrice = this.calculatedPrice
        ? this.calculatedPrice
        : this.product.details.sale_price;
    } else {
      totalPrice =
        this.productDeal.deal_sale_price * this.productDeal.quantity +
        (this.productDeal.deal_sale_price *
          this.productDeal.quantity *
          this.productDeal.deal_convenience_fee) /
        100;
    }

    if (this.couponCode) {
      console.log('applying coupon', this.couponCode);
      this.http
        .post<any>(
          environment.domain + '/api/coupons',
          {
            productId: this.product.details.id,
            couponName: this.couponCode,
            dealId: this.productDeal?.deal_id || 0,
            totalPrice: Math.ceil(totalPrice).toString(),
          },
          httpOptions
        )
        .subscribe(
          (data) => {
            if (data.type === 'success') {
              this.promoCodeApplied = true;
              this.couponResponse = data.data;
              if (this.product.details.product_type !== 'STANDARD') {
                this.calculatedPrice = this.couponResponse.new_price;
                this.applyVoucherLoader = true;
              }
            } else {
              this.promoError = data.message;
              this.applyVoucherLoader = true;
            }
          },
          (error) => {
            console.error('There was an error!', error);
            this.loadingBar.stop();
            this.applyVoucherLoader = true;
          }
        );
    } else {
      this.promoError = 'Please enter coupon';
      this.applyVoucherLoader = true;
    }
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (!this.paymentCompleted && this.product) {
      const result = this.dialogService.confirm(
        'Leaving this page will cancel your transaction. Do you still want to exit?'
      );
      console.log(result);
      return result;
    } else {
      return true;
    }
  }

  getProductDetails(): void {
    this.loadingBar.start();
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    // const localProduct: any = localStorage.getItem('product');

    this.http
      .post<any>(
        environment.domain +
        '/api/' +
        this.product.details.city +
        '/product-details',
        {
          slug: this.product.details.slug,
          city: this.appService.getCurrentCity(),
        },
        httpOptions
      )
      .subscribe(
        (data) => {
          this.loadingBar.stop();
          this.product = data.products;
          localStorage.setItem('product', JSON.stringify(data.products));

          if (this.product.products_standard_deals.length > 0) {
            // check the deal id and update the price
            for (let newDealInfo of this.product.products_standard_deals) {
              if (newDealInfo.deal_id === this.productDeal.deal_id) {
                this.productDeal.deal_regular_price =
                  newDealInfo.deal_regular_price;
                this.productDeal.deal_sale_price = newDealInfo.deal_sale_price;
                this.productDeal.deal_stock = newDealInfo.deal_stock;
                this.productDeal.deal_convenience_fee =
                  newDealInfo.deal_convenience_fee;
              }
            }
          }
        },
        (error) => {
          this.loadingBar.stop();
          console.error('There was an error!', error);
        }
      );
  }

  checkBalance(): void {
    let total_amount = $('.total-amount-balance').text().replaceAll(',', '');
    total_amount = total_amount.match(/\d+/g);

    if (this.checkBalancePayLoad.mobilenumber) {
      this.checkBalanceAccountError = '';
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      };
      const params = {
        mobile: this.checkBalancePayLoad.mobilenumber,
      };

      this.http
        .post<any>(
          environment.domain + '/api/is-mobile-linked',
          params,
          httpOptions
        )
        .subscribe(
          (responseData) => {
            this.checkBalanceResponseReceived = true;
            if (responseData.data.status == 'YES') {
              this.http
                .post<any>(
                  environment.domain + '/api/get-account-balance',
                  params,
                  httpOptions
                )
                .subscribe(
                  (resultData) => {
                    console.log(resultData);
                    if (resultData.type == 'success') {
                      if (resultData.data.AvailablePointsAmount > 0) {
                        this.checkBalanceSuccessful = true;
                        this.GetAccountBalance = resultData.data;

                        if (
                          total_amount < resultData.data.AvailablePointsAmount
                        ) {
                          this.loy_points_amount = total_amount[0];
                        } else {
                          this.loy_points_amount =
                            resultData.data.AvailablePointsAmount;
                        }
                      } else {
                        this.checkBalanceAccountError = 'Points not available';
                      }
                      this.checkBalanceResponseReceived = true;
                    } else {
                      this.checkBalanceSuccessful = true;
                      this.checkBalanceAccountError = 'Account not found';
                    }
                  },
                  (error) => {
                    console.error('There was an error!', error);
                    this.checkBalanceAccountError =
                      'Some error occurred.' + error;
                  }
                );
            } else {
              this.checkBalanceAccountError = 'Account not found';
            }
          },
          (error) => {
            console.error('There was an error!', error);
            this.checkBalanceAccountError = 'Some error occurred.' + error;
          }
        );
    } else {
      this.checkBalanceAccountError =
        'Please enter Zillion number/mobile number';
    }
  }

  changeLoyAmount(searchValue: any): void {
    searchValue = searchValue.replace(/[^0-9]/g, '');
    this.loy_points_amount = searchValue;
  }

  resendOTPPayback(): void {
    this.resendOTPPaybackInProgress = true;
    this.receivedResentOTPPaybackResponse = false;
    if (this.loy_points_amount > this.GetAccountBalance.AvailablePointsAmount) {
      this.useLoyPointsError =
        'Your Available Coins is ' +
        this.GetAccountBalance.AvailablePointsAmount * 4;
    } else {
      this.useLoyPointsError = '';
      this.redeemPointsSuccess = true;
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      };
      const params = {
        mobile: this.checkBalancePayLoad.mobilenumber,
      };
      this.http
        .post<any>(
          environment.domain + '/api/generate-otp',
          params,
          httpOptions
        )
        .subscribe(
          (resultData) => {
            if (resultData.type == 'success') {
              this.resendOTPPaybackInProgress = false;
              this.receivedResentOTPPaybackResponse = true;
            }
          },
          (error) => {
            console.error('There was an error!', error);
          }
        );
    }
  }
  clearPaybackPointData(): void {
    if (!this.currentUser) {
      this.showLoginForm();
    } else {
      this.checkBalanceResponseReceived = false;
      this.checkBalanceSuccessful = false;
      this.checkBalancePayLoad.mobilenumber = this.currentUser.mobile_number;
      this.loy_points_amount = 0;
      this.block_loy_points_amount = 0;
      this.GetAccountBalance = '';
      UIkit.modal('#modal-loyal-points').show();
    }
  }
  removePaybackPoint(): void {
    this.redeemPointsSuccess = false;
    this.loy_points_amount = 0;
    this.block_loy_points_amount = 0;
    this.ReceiptCode = '';
    this.resendOTPPaybackInProgress = false;
    this.receivedResentOTPPaybackResponse = false;
  }
  submitRedeemPoints(): void {
    if (this.loy_points_amount == 0) {
      this.useLoyPointsError =
        'Zero not allow';
    } else if (this.loy_points_amount > this.GetAccountBalance.AvailablePointsAmount) {
      this.useLoyPointsError =
        'Your Available Coins is ' +
        this.GetAccountBalance.AvailablePointsAmount * 4;
    } else {
      this.useLoyPointsError = '';
      this.redeemPointsSuccess = true;
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      };
      const params = {
        mobile: this.checkBalancePayLoad.mobilenumber,
      };

      this.http
        .post<any>(
          environment.domain + '/api/generate-otp',
          params,
          httpOptions
        )
        .subscribe(
          (resultData) => {
            if (resultData.type == 'success') {
              UIkit.modal('#modal-loyal-points').hide();
              UIkit.modal('#modal-block-points-redemption').show();
            }
          },
          (error) => {
            console.error('There was an error!', error);
          }
        );
    }
  }

  /**Earn Loyalty Points */
  earnLoyaltyCheck(): void {
    if (this.earnLoyaltyPayLoad.earn_mobile_number) {
      if (this.earnLoyaltyPayLoad.earn_mobile_number.length == 10) {
        this.checkBalanceAccountError = '';
        this.earnLoyaltyAccountError = '';
        const httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };
        const params = {
          mobile: this.earnLoyaltyPayLoad.earn_mobile_number,
        };

        this.http
          .post<any>(
            environment.domain + '/api/is-mobile-linked',
            params,
            httpOptions
          )
          .subscribe(
            (responseData) => {
              this.checkBalanceResponseReceived = true;
              if (responseData.data.status == 'YES') {
                this.AuthenticationNumber =
                  this.earnLoyaltyPayLoad.earn_mobile_number;

                var eligible_points = 0;
                if (this.product.details.product_type !== 'STANDARD') {
                  eligible_points = (this.productSchedule.event_price * 0.025) * 4;
                } else {
                  eligible_points = (this.productDeal.deal_sale_price * this.productDeal.quantity * 0.0125) * 4;
                }
                this.EligiblePaybackAmount = Math.ceil(eligible_points);
                this.earnLoyaltyMobileError = '';
                this.earnLoyaltyAccountError = '';
              } else {
                this.earnLoyaltyMobileError = 'Account not found';
                this.EligiblePaybackAmount = 0;
                this.earnLoyaltyAccountError = '';
              }
            },
            (error) => {
              this.earnLoyaltyMobileError = 'Some error occurred.' + error;
              this.EligiblePaybackAmount = 0;
              this.earnLoyaltyAccountError = '';
            }
          );
      } else {
        this.earnLoyaltyMobileError = '';
        this.earnLoyaltyAccountError = 'Please enter valid mobile number';
        this.EligiblePaybackAmount = 0;
      }
    } else {
      this.earnLoyaltyMobileError = '';
      this.earnLoyaltyAccountError = 'Please enter mobile number';
      this.EligiblePaybackAmount = 0;
    }
  }

  /**Earn Loyalty Points New Member */
  EnrollMember(): void {
    let isValid = true;

    this.earnLoyaltyNewMemberError.mobile_number = '';
    this.earnLoyaltyNewMemberError.email = '';
    this.earnLoyaltyNewMemberError.salutation = '';
    this.earnLoyaltyNewMemberError.first_name = '';
    this.earnLoyaltyNewMemberError.last_name = '';
    this.earnLoyaltyNewMemberError.dob = '';
    this.earnLoyaltyNewMemberError.privacy_checkbox = '';
    this.earnLoyaltyMobileError = '';

    if (this.earnLoyaltyNewMemberPayLoad.mobile_number == '') {
      this.earnLoyaltyNewMemberError.mobile_number =
        'Please enter mobile number';
      isValid = false;
    } else if (
      !this.validPhoneNumber(this.earnLoyaltyNewMemberPayLoad.mobile_number)
    ) {
      this.earnLoyaltyNewMemberError.mobile_number = 'Invalid mobile number';
      isValid = false;
    }
    if (this.earnLoyaltyNewMemberPayLoad.email == '') {
      this.earnLoyaltyNewMemberError.email = 'Please enter Email';
      isValid = false;
    } else if (!this.validateEmail(this.earnLoyaltyNewMemberPayLoad.email)) {
      this.earnLoyaltyNewMemberError.email = 'Invalid Email';
      isValid = false;
    }
    if (this.earnLoyaltyNewMemberPayLoad.salutation == '') {
      this.earnLoyaltyNewMemberError.salutation = 'Please select salutation';
      isValid = false;
    }
    if (this.earnLoyaltyNewMemberPayLoad.first_name == '') {
      this.earnLoyaltyNewMemberError.first_name = 'Please enter first name';
      isValid = false;
    }
    if (this.earnLoyaltyNewMemberPayLoad.last_name == '') {
      this.earnLoyaltyNewMemberError.last_name = 'Please enter last name';
      isValid = false;
    }
    if (this.earnLoyaltyNewMemberPayLoad.dob == '') {
      this.earnLoyaltyNewMemberError.dob = 'Please enter date of birth';
      isValid = false;
    } else if (this.earnLoyaltyNewMemberPayLoad.dob) {
      var CurrentDate = new Date();
      let GivenDate = new Date(this.earnLoyaltyNewMemberPayLoad.dob);
      if (GivenDate > CurrentDate) {
        this.earnLoyaltyNewMemberError.dob = 'Please enter date of birth';
        isValid = false;
      }
    }
    if ($('#privacy_checkbox').prop('checked') == false) {
      this.earnLoyaltyNewMemberError.privacy_checkbox =
        'Please accept privacy policy, terms and conditions,';
      isValid = false;
    }
    if (isValid) {
      this.checkBalanceAccountError = '';
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      };
      const params = {
        mobile_number: this.earnLoyaltyNewMemberPayLoad.mobile_number,
        email: this.earnLoyaltyNewMemberPayLoad.email,
        salutation: this.earnLoyaltyNewMemberPayLoad.salutation,
        first_name: this.earnLoyaltyNewMemberPayLoad.first_name,
        last_name: this.earnLoyaltyNewMemberPayLoad.last_name,
        dob: this.earnLoyaltyNewMemberPayLoad.dob,
      };

      this.http
        .post<any>(
          environment.domain + '/api/enrol-member',
          params,
          httpOptions
        )
        .subscribe(
          (responseData) => {
            this.checkBalanceResponseReceived = true;
            if (responseData.data.ErrorMessage != '') {
              this.earnLoyaltyMobileError = responseData.data.ErrorMessage;
            } else {
              this.AuthenticationNumber =
                this.earnLoyaltyNewMemberPayLoad.mobile_number;
              this.enrol_member_response = responseData.data;
              const httpOptions = {
                headers: new HttpHeaders({
                  'Content-Type': 'application/json',
                }),
              };
              const params = {
                mobile: this.earnLoyaltyNewMemberPayLoad.mobile_number,
              };
              this.http
                .post<any>(
                  environment.domain + '/api/generate-otp',
                  params,
                  httpOptions
                )
                .subscribe(
                  (resultData) => {
                    if (resultData.type == 'success') {
                      UIkit.modal('#validate-otp-modal').show();
                    }
                  },
                  (error) => {
                    console.error('There was an error!', error);
                  }
                );
            }
          },
          (error) => {
            this.earnLoyaltyMobileError = 'Some error occurred.' + error;
          }
        );
    } else {
      this.earnLoyaltyMobileError = 'Please enter mobile number';
    }
  }
  EarnSendOtpVerify(): void {
    UIkit.modal('#validate-otp-modal').hide();
    let total_amount = $('.total-amount-balance').text().replaceAll(',', '');
    total_amount = total_amount.match(/\d+/g);
    var eligible_points = 0;
    if (this.product.details.product_type !== 'STANDARD') {
      eligible_points = (this.productSchedule.event_price * 0.025) * 4;
    } else {
      eligible_points = (this.productDeal.deal_sale_price * this.productDeal.quantity * 0.0125) * 4;
    }
    this.EligiblePaybackAmount = Math.ceil(eligible_points);
  }

  EarnPaybackResendOtp(): void {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    const params = {
      mobile: this.earnLoyaltyNewMemberPayLoad.mobile_number,
    };
    this.http
      .post<any>(environment.domain + '/api/generate-otp', params, httpOptions)
      .subscribe(
        (resultData) => {
          if (resultData.type == 'success') {
            UIkit.modal('#validate-otp-modal').show();
          }
        },
        (error) => {
          console.error('There was an error!', error);
        }
      );
  }
  /**Validate OTP */
  ngOnDestroy(): void {
    // localStorage.removeItem('product');
    // localStorage.removeItem('deal');
    clearInterval(this.productCheckUpdate);
  }
}
